import { Hall } from '@db8/shared'
import { useAblyTypedPubSub } from '../use-ably'

export const useHallPubSub = ({
  hall,
  setHall,
}: {
  hall: Hall | null
  setHall: (hall: any) => void
}) => {
  const { publish } = useAblyTypedPubSub<any>('HALL', ({ data }) => {
    setHall((prev) => ({ ...prev, ...data }))
  })

  const publishHall = (message: any) => {
    publish(message)
  }

  return {
    publishHall,
    hall,
  }
}
